import { render, staticRenderFns } from "./ReportAppCustomerServiceDetail.vue?vue&type=template&id=64b079f7&scoped=true&"
import script from "./ReportAppCustomerServiceDetail.vue?vue&type=script&lang=js&"
export * from "./ReportAppCustomerServiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b079f7",
  null
  
)

export default component.exports